<template>
    <div class="faq-box">
        <ChildBanner :childbannerData='childbannerData' ref='childBaner' class="white"></ChildBanner>
        <FaqValue ref='faqvalue' class="black"></FaqValue>
    </div>
</template>
<script>
    import ChildBanner from '@/components/base/childbanner'//引入子页面的banner
    import FaqValue from '@/components/main/faq/faq'//引入问题    
    export default {
        name: 'Faq',
        data() {
            return {
                childbannerData: {
                    childbanner: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/FQA/%E7%BB%84%20752.jpg',
                    caption: 'FAQ',
                    title: '常见问题'
                },
            }
        },
        components: {
            ChildBanner,
            FaqValue
        },
        methods: {
            childMethods() {
                this.$refs.childBaner.changeShow()
            },
            faqnavmove() {
                this.$refs.faqvalue.faqnavmove()
            }
        }

    }
</script>
<style scoped>
    .faqvalue>>>.faqvalue-box {
        padding: 181px 0;
        display: flex;
        flex-direction: column;
        -ms-flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/pages/main/faq.vue